import { config } from 'lib-shared-backend-config';

export function getMessengerWidgetTokenAndUrl(): Record<
  'messengerToken' | 'loaderUrl',
  string
> {
  return {
    messengerToken: config.sdk.messenger.token[config.environment],
    loaderUrl: `${config.url.messenger}/bootstrap.js`,
  };
}
